import * as React from 'react'
import { Defs, LinearGradient, Stop, Path } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'
import { svgIdentifier } from 'ui/svg/utils'

import { AccessibleBicolorIcon } from './types'

const BicolorPhonePendingSvg: React.FC<AccessibleBicolorIcon> = ({
  size,
  color,
  color2,
  accessibilityLabel,
  testID,
}) => {
  const { id: gradientId, fill: gradientFill } = svgIdentifier()

  const height = typeof size === 'string' ? size : ((size as number) * 156) / 200
  return (
    <AccessibleSvg
      width={size}
      height={height}
      viewBox="0 0 200 156"
      fill="none"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.8613 17.9897L110.978 13.0003L110.986 13.0071C114.896 12.8383 118.292 15.7158 118.742 19.6095L118.743 19.6217L118.765 19.8405L123.706 78.3851C123.819 79.7249 122.821 80.8962 121.487 81.0088C120.213 81.1164 119.081 80.221 118.882 78.9738L118.88 78.958L118.862 78.8058L113.92 20.2504C113.803 18.862 112.612 17.8131 111.222 17.8573L111.072 17.8664L52.2717 22.829C50.8676 22.9476 49.8208 24.1407 49.8655 25.5176L49.8737 25.6669L50.6682 35.0809L102.284 30.7246C103.533 30.6192 104.791 31.4328 104.902 32.7522C105.008 34.0096 104.005 34.9942 102.833 35.1699L102.821 35.1718L102.672 35.1891L51.0451 39.5463L57.452 115.458L98.9818 111.896C99.0248 111.893 99.0678 111.89 99.1108 111.889C99.4505 108.062 100.561 104.446 102.297 101.216C102.879 100.133 104.229 99.7265 105.313 100.309C106.397 100.891 106.803 102.241 106.221 103.325C104.453 106.614 103.455 110.388 103.455 114.396C103.455 127.402 113.994 137.942 127 137.942C140.006 137.942 150.545 127.402 150.545 114.396C150.545 101.39 140.006 90.8507 127 90.8507C122.939 90.8507 119.119 91.8818 115.779 93.6975C114.698 94.285 113.346 93.8852 112.758 92.8044C112.171 91.7237 112.571 90.3714 113.651 89.7839C117.626 87.6231 122.175 86.3961 127 86.3961C142.466 86.3961 155 98.9297 155 114.396C155 129.863 142.466 142.396 127 142.396C118.937 142.396 111.671 138.99 106.562 133.537L106.424 133.554L61.9543 137.564C57.9135 137.906 54.3467 134.979 53.8852 130.982L53.8837 130.97L53.8633 130.762L53.8623 130.751L45.0268 26.0639C44.686 22.0257 47.63 18.4732 51.6312 18.0125L51.6431 18.0111L51.8613 17.9897ZM103.091 128.979C100.821 125.264 99.3919 120.978 99.0696 116.386L57.8289 119.924L58.7081 130.341C58.8253 131.729 60.0157 132.778 61.4057 132.734L61.5557 132.725L103.091 128.979ZM78.9516 26.4477C78.7783 24.3939 80.2967 22.5865 82.3491 22.4132C84.3981 22.2403 86.2014 23.7669 86.3748 25.8212C86.5485 27.8789 85.0258 29.6827 82.9773 29.8556C80.9253 30.0288 79.1253 28.505 78.9516 26.4477ZM127 95.1343C128.23 95.1343 129.227 96.1315 129.227 97.3616V113.474L135.939 120.185C136.808 121.055 136.808 122.465 135.938 123.335C135.069 124.205 133.658 124.205 132.789 123.335L125.425 115.971C125.007 115.553 124.773 114.987 124.773 114.396V97.3616C124.773 96.1315 125.77 95.1343 127 95.1343Z"
        fill={gradientFill}
      />
      <Defs>
        <LinearGradient
          id={gradientId}
          x1="48.841%"
          x2="51.159%"
          y1="0%"
          y2="100%"
          gradientUnits="userSpaceOnUse">
          <Stop offset="0%" stopColor={color2} />
          <Stop offset="100%" stopColor={color} />
        </LinearGradient>
      </Defs>
    </AccessibleSvg>
  )
}

export const BicolorPhonePending = styled(BicolorPhonePendingSvg).attrs(
  ({ color, color2, size, theme }) => ({
    color: color ?? theme.colors.primary,
    color2: color2 ?? color ?? theme.colors.secondary,
    size: size ?? theme.illustrations.sizes.medium,
  })
)``
